import React, { Component } from 'react';
import classNames from 'classnames';
import { translate } from 'react-i18next';
import PropTypes from 'prop-types';
import i18n from '../I18n'; // eslint-disable-line no-unused-vars

class LanguageSwitcher extends Component {
  constructor(props) {
    super(props);
    const { i18n } = this.props;
    this.state = { language: i18n.language };

    this.handleChangeLanguage = this.handleChangeLanguage.bind(this);
  }

  componentWillReceiveProps(nextProps) {
    this.setState({ language: nextProps.i18n.language });
  }

  handleChangeLanguage(lng) {
    const { i18n } = this.props;
    i18n.changeLanguage(lng);
  }

  renderLanguageChoice({ code, label }) {
    const buttonClass = classNames('dropdown-item', {
      'dropdown-item--selected': this.state.language === code,
    });

    return (
      <a
        key={code}
        className={buttonClass}
        onClick={() => this.handleChangeLanguage(code)}
      >
        {label}
      </a>
    );
  }

  render() {
    const languages = [
      { code: 'en', label: 'English' },
      { code: 'fr', label: 'Français' },
    ];

    const { t } = this.props;
    return (
      <li className="nav-item dropdown" role="presentation">
        <a
          href="#"
          className="nav-link dropdown-toggle active"
          data-toggle="dropdown"
          role="button"
          aria-haspopup="true"
          aria-expanded="false"
        >
          <span className="icon-international-globe" aria-hidden="true" />
          <span>{t('title')}</span>
        </a>
        <ul className="dropdown-menu dropdown-menu-right" role="menu">
          {languages.map(language => this.renderLanguageChoice(language))}
        </ul>
      </li>
    );
  }
}

LanguageSwitcher.propTypes = {
  t: PropTypes.func.isRequired,
  i18n: PropTypes.object.isRequired,
};
export default translate('LanguageSwitcher')(LanguageSwitcher);



// WEBPACK FOOTER //
// ./src/components/LanguageSwitcher/index.js